import React from "react";
import Nav from "./layout/Nav";
import Footer from "./layout/Footer";
export default function FrontendLayout({ children }) {
  return (
    <div className="frontend">
      <Nav />
      {children}
      <Footer />
    </div>
  );
}
